/***
 * 创建人：李珊
 * 时间：2020-11-27
 * 描述: 对齐编辑页面
 * 使用说明:
 * 更新说明:
 */
import { Component, OnInit } from '@angular/core';
import { KmsService } from '../../../kms.service';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { DictionaryService } from '../../../../../librarys/serves/public/dictionary.service';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { KmsEnum } from '../../../serves/kms-enum';
declare var $;
@Component({
  selector: 'app-aligedit-edit',
  templateUrl: './aligedit-edit.component.html',
  styleUrls: ['./aligedit-edit.component.css']
})
export class AligeditEditComponent implements OnInit {
  // 是否为初始化状态
  isInit = true;
  // 查询关键字
  keyword = '';
  // 查询结果
  datas:any = [];
  // 当前选择的需进行对齐的实体
  currentInstance:any = {
    instanceName: ''
  };
  // 头部概念选中ID
  activeTreeId: any = '5732680222a24a0eb803f51e097fd17e';
  // 高级属性表单结构，用来渲染表单
  baseInfoConfig = [];
  // 添加一行时依赖的模板配置
  attrs = [];
  // 实体信息
  instanceData:any = {}
  // 是否显示正在加载中
  isLoading = false;
  // 表单push数据
  attributeChNameForm: any;
  // 表单验证失败的字段名数组
  errorList = [];
  // 表单月数据
  monthArr = [];
  // 表单日数据
  dayArr = [];
  // 表单，三元组数据所需数据结构
  tripleFormDatas = [];
  attributeOptions = [{
    'id': 'fda5c6bce2e247779ac66bc6bcfcc1ac',
    'text': '正名'
  },{
    'id': '74c71831c04b4193bb8bed93897a22f9',
    'text': '别名'
  },{
    'id': 'e71a29091ccb45a1922fe62fcdb1b4e0',
    'text': '字'
  },{
    'id': 'f08bd06c5bb24219801a5bba7f313bee',
    'text': '号'
  },{
    'id': 'bd34d6f5272649dca60474414fcf352b',
    'text': '名称备注'
  }]
  // 抽取的三元组信息
  extractResult = [];
  // 当前是否已展示连线
  showLines = false;
  // 表单控件类型
  formControlTypes = KmsEnum.FORM_CONTROL_TYPES;
  constructor(
    private kmsService: KmsService,
    private dicService: DictionaryService,
    private message: SwMassageBoxService,
    private instanceModuleService: InstanceModuleService
  ) { }

  ngOnInit() {

  }

  //enter键触发搜索
  enterSearch(event){
    if(event.keyCode == '13'){
        this.search();
    }
  }

  // 根据实体名称搜索
  search(){
    let Params = {
      current: 1,
      size: 10,
      instanceName: $.trim(this.keyword)
    };
    this.kmsService.getInstanceQueryList(Params).subscribe(
      data => {
            if (data.code == 200) {
                this.datas = data.data.records;
            } else {
                this.message.waring(data.msg);
            }
        }
    );
  }

  // 选择某一项进行对齐操作
  selectInstance(data){
    this.isInit = false;
    this.currentInstance = data;
    this.getInstanceById(data.instanceId);
    this.getAligentInfo();
  }

  // 根据实体ID查询实体详细信息
  getInstanceById(id) {
    this.isLoading = true;
    this.kmsService.getInstanceById(id).subscribe(
        result => {
            if (result.code == 200) {
                let datas = result.data;
                this.instanceData = datas;
                this.getInstanceFormData(this.instanceData.conceptId);
            }
        }
    )
  }

  // 根据概念id查询属性字段列表
  getInstanceFormData(id) {
    this.kmsService.getAttributeForForm(id).subscribe(
        result => {
            this.isLoading = false;
            if (result.code == '200') {

            // 渲染基本信息表格
            let datas = result.data.attrs;
            // 实体新增时
            for (let i = 0; i < datas.length; i++) {
                let attrDatas;
                attrDatas = datas[i];
                for (let j = 0; j < attrDatas.length; j++) {
                    attrDatas[j].attributeChName = '';
                    attrDatas[j].sourceName = '';
                    attrDatas[j].id = 0;
                    attrDatas[j].triplesId = attrDatas[0].englishCode;
                    attrDatas[j].attributeChNameOther = '';
                    // 当输入类型为下拉框时，获取下拉选项数组
                    if (attrDatas[j].fieldType == this.formControlTypes.dropBox && attrDatas[j].dictionryCode) {
                        attrDatas[j]['options'] = this.dicService.getDictionaryValueOrName(
                            attrDatas[j].dictionryCode
                        );
                    }
                }
            }
            // 保存属性结构数据用于筛选删除
            this.attributeChNameForm = JSON.parse(JSON.stringify(datas));
            datas = this.editFormData(datas);
            // 保存属性结构数据
            this.baseInfoConfig = datas;
        } else {
            this.message.waring(result.msg);
        }
    });
  }

  // 实体编辑处理表单结构
  editFormData(datas) {
    // 当前实体详细包含的三元组数据内容
    let triples = this.instanceData.attrs;
    if (!datas.list) {
        datas.filter((item, index) => {
            let itemDatas, status = 0;
            if (item.list) {
                itemDatas = item.list[0];
                itemDatas[0].triplesId = itemDatas[0].englishCode;
                itemDatas[0].id = 0;
                itemDatas[0].attributeChName = '';
                itemDatas[0].sourceName = '';
                status = 1;
            } else {
                itemDatas = item[0];
                itemDatas.id = 0;
                itemDatas.triplesId = itemDatas.englishCode;
                itemDatas.attributeChName = '';
                itemDatas.sourceName = '';
                if (itemDatas.dictionryCode) {
                    // 表单属性结构字典存在
                    itemDatas.options = this.dicService.getDictionaryValueOrName(
                        itemDatas.dictionryCode
                    );
                }
            }

            if (triples && triples.length > 0) {
                for (let i = 0; i < triples.length; i++) {
                    itemDatas = JSON.parse(JSON.stringify(itemDatas));
                    if (status == 1) {
                        // 特殊表单结构
                        if (itemDatas[0].attributeId == triples[i].relationshipId) {
                            // uuid不存在，表示当前字段编辑时有初始数据，需删除第一条默认数据
                            if (!itemDatas[0].uuid) {
                                datas[index].list.splice(0, 1);
                            }
                            if (triples[i].dictCode) {
                                // 特殊表单备注存在
                                itemDatas[0].attributeChNameOther = triples[i].dictCode;
                                itemDatas[1].attributeChName = triples[i].dictCode;
                            }
                            itemDatas[0].attributeChName = triples[i].attributeValue;
                            itemDatas[0].sourceName = triples[i].datasource == 'none' ? '' : triples[i].datasource;
                            itemDatas[0].uuid = triples[i].uuid;
                            itemDatas[0].triplesId = triples[i].uuid;
                            itemDatas[0].id = triples[i].sortNum;
                            datas[index].list.push(itemDatas);
                        }
                    } else {
                        // 普通表单结构
                        if (itemDatas.attributeId == triples[i].relationshipId) {
                            // uuid不存在，表示当前字段编辑时有初始数据，需删除第一条默认数据
                            if (!itemDatas.uuid) {
                                datas[index].splice(0, 1);
                            }

                            if (itemDatas.dictionryCode && triples[i].dictCode) {
                                // 返回数据存在字典值时（下拉数据）
                                itemDatas.attributeChName = triples[i].dictCode;
                            } else {
                                // 表单属性结构字典不存在
                                if (triples[i].dictCode) {
                                    // 返回数据存在字典值时（特殊字段数据，如时间）
                                    itemDatas.attributeChNameOther = triples[i].attributeValue;
                                    itemDatas.attributeChName = triples[i].dictCode;
                                } 
                                if (triples[i].dictCode === 'none') {
                                    itemDatas.attributeChName = triples[i].attributeValue;
                                }
                            }
                            if (triples[i].datasource === 'null' || triples[i].datasource === 'none') {
                                itemDatas.sourceName = '';
                            } else {
                                itemDatas.sourceName = triples[i].datasource;
                            }
                            itemDatas.uuid = triples[i].uuid;
                            itemDatas.triplesId = triples[i].uuid;
                            itemDatas.id = triples[i].sortNum;
                            datas[index].push(itemDatas);
                        }
                    }
                }
            }

        });
    }
    return JSON.parse(JSON.stringify(datas));;
  }

  // 表单新增字段属性和属性来源内容
  handleAddFormClick(index) {
    // let datas = JSON.parse(JSON.stringify(this.attributeChNameForm[index][0]));
    // if (datas.attributeChNameOther) {
    //     datas.attributeChNameOther = '';
    // }
    // datas.sourceName = '';
    // datas.attributeChName = '';
    // datas.id = this.baseInfoConfig[index].length;
    // datas.triplesId = this.getTimeReturnId();
    // datas.uuid = '';
    // this.baseInfoConfig[index].push(datas);
  }

  // 根据当前时间生成唯一ID值
  getTimeReturnId() {
    let date = new Date();
    // 得到时间的13位毫秒数
    return date.getTime();
  }

  // 表单删除字段属性和属性来源内容
  handleDelFormClick(oneIndex, twoIndex) {
    /*
        oneIndex： 当前字段在整个表单的索引值
        twoIndex： 当前字段在特殊表单的索引值
    */

    // let datas;
    // let uuid;  // 三元组数据ID
    // let triplesId;  // 当前三元组数据表单ID，用于做页面新增、删除表单判断

    // datas = JSON.parse(JSON.stringify(this.baseInfoConfig[oneIndex]));
    // uuid = datas[twoIndex].uuid;
    // triplesId = datas[twoIndex].triplesId;

    // // 判断三元组数据ID是否存在
    // if (uuid) {
    //     this.deleteDatabaseDatas(uuid, datas, twoIndex, triplesId, oneIndex);
    // } else {
    //     if (datas.length > 1) {
    //         datas.splice(twoIndex, 1);
    //     } else {
    //         datas[0].attributeChName = '';
    //         datas[0].attributeChNameOther = '';
    //         datas[0].sourceName = '';
    //     }
    //     this.baseInfoConfig[oneIndex] = datas;
    //     this.deleteTripleFormDatas(triplesId);
    // }
  }

  // 删除数据库的三元组数据
  deleteDatabaseDatas(uuid, datas, twoIndex, triplesId, oneIndex) {
    this.kmsService.deleteInstanceByAttribute(
        'nodeId=' + this.instanceData.instanceId +
        "&&uuid=" + uuid
    ).subscribe(
        data => {
            if (data.code == '200') {
                this.deleteTripleFormDatas(triplesId);
                if (datas.length > 1) {
                    datas.splice(twoIndex, 1);
                } else {
                    datas[0].attributeChName = '';
                    datas[0].attributeChNameOther = '';
                    datas[0].sourceName = '';
                }
                this.baseInfoConfig[oneIndex] = datas;
            } else {
                this.message.waringError(data.msg);
            }
        }
    );
  }

  // 删除需要保存表单的三元组数据
  deleteTripleFormDatas(id) {
    if (this.tripleFormDatas.length > 0) {
        this.tripleFormDatas.filter((item, index) => {
            // 判断是否已经加入过tripleFormDatas数组
            if (item.triplesId == id) {
                this.tripleFormDatas.splice(index, 1);
            }
        })
    }
  }

  // 表单内容，日期年月日赋值
  getYearOrMonthOrDay(type, keyName, m, item) {
    let index = String(m);
    let val = $('#' + item + keyName + index).val();
    if (val) {
        let str = this.instanceModuleService.getYearOrMonthOrDay(type, val);
        return str;
    }
  }

  // 表单内容，监听时间输入框的变化，判断是否合法
  getDateStr(keyName, oneIndex, twoIndex, type) {
    /*
        keyName: 当前字段信息的英文标识值
        oneIndex: 当前字段在整个表单结构的索引值
        twoIndex: 当前字段在表单的索引值
        type: 当前字段属于（special：特殊表单字段，note：带备注信息字段，no：不带备注信息字段）
    */

    let index = String(twoIndex);
    let parent = $('#' + type + keyName + index).parent();
    const yearValue = parent.find('.year').val();
    const monthValue = parent.find('.month').val();
    const dayValue = parent.find('.day').val();

    // 返回时间 年/月/日
    let res = this.instanceModuleService.validateTime(yearValue, monthValue, dayValue);

    // 将 年/月/日 赋值给隐藏的输入框
    $('#' + type + keyName + index).val(res.timeStr);


    // 判断 年/月/日 表单验证是否输入合法
    if (!res.isValid) {
        if (this.errorList.indexOf(keyName) < 0) {
            this.errorList.push(keyName);
            parent.parent().find('.tip-error').removeClass('hidden');
            parent.find('.year,.month,.day').addClass('input-error');
        }
    } else {
        const index = this.errorList.indexOf(keyName);
        if (index >= 0) {
            this.errorList.splice(index, 1);
            parent.parent().find('.tip-error').addClass('hidden');
            parent.find('.year,.month,.day').removeClass('input-error');
        }
    }

    let datas;
    if (type === 'note'){
        // 转换数据，得到当前字段在特殊表单属于哪条数据
        datas = JSON.parse(JSON.stringify(this.baseInfoConfig[oneIndex][twoIndex]));
        // 将隐藏输入框的 年/月/日 赋值给表单数组
        datas.attributeChName = $('#' + type + keyName + index).val();
        this.baseInfoConfig[oneIndex][twoIndex] = datas;
    } else if (type === 'no') {
        // 转换数据，得到当前字段在特殊表单属于哪条数据
        datas = JSON.parse(JSON.stringify(this.baseInfoConfig[oneIndex][twoIndex]));
        // 将隐藏输入框的 年/月/日 赋值给表单数组
        datas.attributeChName = $('#' + type + keyName + index).val();
        this.baseInfoConfig[oneIndex][twoIndex] = datas;
        let this_ = this;
        setTimeout(function () {
            this_.handleFormChange(this_.baseInfoConfig[oneIndex][twoIndex])
        }, 500)
    }

    // 获取年号数据，存储到时间备注里
    if (yearValue && type !== 'no') {
        if (yearValue > 1949) {
            datas.attributeChNameOther = `${yearValue}年`;
            this.baseInfoConfig[oneIndex][twoIndex] = datas;
        } else {
            this.kmsService.getInstanceTimeNoteByYear(yearValue).subscribe(
                data => {
                    if (data.code == '200') {
                        const res = data.data;
                        datas.attributeChNameOther = res;
                        this.baseInfoConfig[oneIndex][twoIndex] = datas;
                    } else {
                        console.log(data.msg);
                    }
                }
            );
        }
        let this_ = this;
        if (type === 'note') {
            setTimeout(function () {
                this_.handleFormChange(this_.baseInfoConfig[oneIndex][twoIndex])
            }, 500)
        }
    }
  }

  // 监听表单是否发生变化
  handleFormChange(event) {
    let status = 0, deleteStatus = 0;

    //  判断是否执行清空删除三元组数据方法
    if (event.fieldType === this.formControlTypes.geoRemark) {
        if (event.uuid && !event.attributeChNameOther) {
            deleteStatus = 1;
        }
    } else {
        if (event.uuid && !event.attributeChName) {
            deleteStatus = 1;
        }
    }
    if (deleteStatus === 1) {
        this.kmsService.deleteInstanceByAttribute(
            'nodeId=' + this.instanceData.instanceId +
            "&&uuid=" + event.uuid
        ).subscribe(
            data => {
                if (data.code == '200') {
                    this.deleteTripleFormDatas(event.triplesId);
                    status = 1;
                } else {
                    this.message.waringError(data.msg);
                }
            }
        );
    }

    // 表示当前数据不存在uuid
    if (status === 0) {
        if (this.tripleFormDatas.length > 0) {
            let status = true;
            this.tripleFormDatas.filter((item, index) => {
                // 判断是否已经加入过tripleFormDatas数组
                if (item.triplesId == event.triplesId) {
                    this.tripleFormDatas[index] = event;
                    status = false;
                    return;
                }
            })
            if (status) {
                this.tripleFormDatas.push(event);
            }
        } else {
            this.tripleFormDatas.push(event);
        }
    }
  }

  // 保存按钮，表单内容保存
  onSubmit({ value, valid }, event: Event) {

  }

  // 获取对齐属性信息
  getAligentInfo(){
    this.extractResult = [
      {
        'name': '唐寅',
        'key': '中文名',
        'value': '唐寅',
        'attributeCode':'',
        'source': '百度百科',
        'sourceUrl': 'https://baike.baidu.com/item/%E5%94%90%E5%AF%85/22587?fr=aladdin'
      },
      {
        'name': '唐寅',
        'key': '别名',
        'value': '唐伯虎，字子畏，号：六如居士、桃花庵主、鲁国唐生、逃禅仙吏等',
        'attributeCode':'',
        'source': '百度百科',
        'sourceUrl': 'https://baike.baidu.com/item/%E5%94%90%E5%AF%85/22587?fr=aladdin'
      },
      {
        'name': '唐寅',
        'key': '民族',
        'value': '汉族',
        'attributeCode':'',
        'source': '百度百科',
        'sourceUrl': 'https://baike.baidu.com/item/%E5%94%90%E5%AF%85/22587?fr=aladdin'
      },
      {
        'name': '唐寅',
        'key': '出生地',
        'value': '苏州府白下、桥李间',
        'attributeCode':'',
        'source': '百度百科',
        'sourceUrl': 'https://baike.baidu.com/item/%E5%94%90%E5%AF%85/22587?fr=aladdin'
      },
      {
        'name': '唐寅',
        'key': '出生日期',
        'value': '公元1470年3月6日(成化六年二月初四)',
        'attributeCode':'',
        'source': '百度百科',
        'sourceUrl': 'https://baike.baidu.com/item/%E5%94%90%E5%AF%85/22587?fr=aladdin'
      },
      {
        'name': '唐寅',
        'key': '逝世日期',
        'value': '公元1523年12月2日(嘉靖二年十二月二日)',
        'attributeCode':'',
        'source': '百度百科',
        'sourceUrl': 'https://baike.baidu.com/item/%E5%94%90%E5%AF%85/22587?fr=aladdin'
      },
      {
        'name': '唐寅',
        'key': '中文名称',
        'value': '所处朝代',
        'attributeCode':'明朝',
        'source': '百度百科',
        'sourceUrl': 'https://baike.baidu.com/item/%E5%94%90%E5%AF%85/22587?fr=aladdin'
      },
      {
        'name': '唐寅',
        'key': '职业',
        'value': '画家',
        'attributeCode':'',
        'source': '百度百科',
        'sourceUrl': 'https://baike.baidu.com/item/%E5%94%90%E5%AF%85/22587?fr=aladdin'
      },
    ]
  }

  // 自动对齐
  autoAligent(){
    this.drawLines();
  }

  // 绘制连线
  drawLines(){
    this.showLines = true;
    
    // [0,1] 对齐属性模块和实体信息模块的对应索引
    let arr = [[0,0],[1,1],[4,7],[5,8]]

    // 设置画布宽高并获取canvas对象
    let canvas=document.getElementById("lines") as HTMLCanvasElement;
    canvas.width = $('.linesContainer').width() + 76
    canvas.height = $('.aligeditEditPage>.row').height()
    const ctx = canvas.getContext('2d'); // 获取 Canvas 上下文

    // 每次绘制前需清除之前的内容
    // 绘制连线
    ctx.fillStyle = '#f8f9f9'
    ctx.fillRect(0,0,canvas.width,canvas.height);
    
    arr.forEach(item => {
      // 获取绘制线段及箭头的坐标点
      let element1 = $('.aligentInfo .module-item').eq(item[0])
      let sp = {
        x: canvas.width,
        y: element1.offset().top-$('.aligentInfo').offset().top+element1.height()/2
      };
      let element2 = $('.instanceInfo form .formGroupContent').eq(item[1])
      let ep = {
        x: 0,
        y: element2.offset().top-$('.instanceInfo').offset().top+element1.height()/2
      };
      let secondP = {
        x: ep.x + (sp.x - ep.x)/2,
        y: sp.y
      }
      let thirdP = {
        x: ep.x + (sp.x - ep.x)/2,
        y: ep.y
      }
      let arrowSp = {
        x: ep.x + 8,
        y: ep.y - 8
      }
      let arrowEp = {
        x: ep.x + 8,
        y: ep.y + 8
      }
      
      // 绘制箭头
      ctx.beginPath();
      ctx.moveTo(arrowSp.x, arrowSp.y);
      ctx.lineTo(ep.x, ep.y);
      ctx.lineTo(arrowEp.x, arrowEp.y);
      ctx.setLineDash([0,0]);
      ctx.strokeStyle = '#83302E';
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.closePath();
      
      // 绘制连线
      ctx.beginPath();
      ctx.moveTo(sp.x, sp.y);
      ctx.lineTo(secondP.x, secondP.y);
      ctx.lineTo(thirdP.x, thirdP.y);
      ctx.lineTo(ep.x, ep.y);
      ctx.setLineDash([5,5]);
      ctx.strokeStyle = '#83302E';
      ctx.lineWidth = 2;
      ctx.stroke();
      ctx.closePath();
    })
  }

  // 选择对齐属性时重新绘制连线
  clickChange(event) {
    
  }
}
